module.exports = __webpack_public_path__ + "img/customsDeclarationActive.c8bc585.svg";